export const EMPTY_RESULTS_TEXT = 'No results found'
export const ENTER_KEY = 'Enter'
export const KEY_ARROW_DOWN = 'ArrowDown'
export const KEY_ARROW_UP = 'ArrowUp'
